import React, { createContext, useContext, useMemo, type PropsWithChildren } from 'react';

type PolarisEnvironmentContextType = {
	embedded?: boolean;
	isSharedView?: boolean;
	isCollectionView?: boolean;
};

const initialState: PolarisEnvironmentContextType = {
	embedded: undefined,
	isSharedView: undefined,
	isCollectionView: undefined,
};

const PolarisEnvironmentContext = createContext(initialState);

type PolarisEnvironmentProviderProps = {
	embedded?: boolean;
	isSharedView?: boolean;
	isCollectionView?: boolean;
};

export const PolarisEnvironmentProvider = ({
	children,
	embedded = false,
	isSharedView = false,
	isCollectionView = false,
}: PropsWithChildren<PolarisEnvironmentProviderProps>) => {
	const contextValue = useMemo(
		() => ({
			embedded,
			isSharedView,
			isCollectionView,
		}),
		[embedded, isSharedView, isCollectionView],
	);

	return (
		<PolarisEnvironmentContext.Provider value={contextValue}>
			{children}
		</PolarisEnvironmentContext.Provider>
	);
};

export const useIsEmbedded = (): boolean => {
	const { embedded } = useContext(PolarisEnvironmentContext);
	return embedded === true;
};

export const useIsSharedView = (): boolean => {
	const { isSharedView } = useContext(PolarisEnvironmentContext);
	return isSharedView === true;
};

export const useIsCollectionView = (): boolean => {
	const { isCollectionView } = useContext(PolarisEnvironmentContext);
	return isCollectionView === true;
};
